import React, { useState, useRef } from 'react'
import { globalState } from '../../../../store'

// Components
import GlobalStyles from '../../../../components/component-items/styles'
import { Form, Row, Modal } from 'react-bootstrap'
import GenericModal from '../../../../components/component-items/modal'
import { notify, usePost, useDelete } from '../../../../components/component-items/helpers'

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'

// Types
import { SMSProps } from './types'

export const SMS = ({ userID, smsOpen, method, setSmsOpen, currentPhoneNumber, setCurrentPhoneNumber }: SMSProps) => {
  const [validated, setValidated] = useState(false)
  const node = useRef<HTMLFormElement | null>(null)
  const [phone, setPhone] = useState('')
  const [code, setCode] = useState('')
  const [submittedPhone, setSubmittedPhone] = useState(false)
  const {
    state: { csrf },
  } = globalState()

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    e.stopPropagation()
    const form = e.currentTarget
    setValidated(true)
    if (form.checkValidity() === false) {
      return
    } else {
      if (!submittedPhone) {
        // Send phone number to the server
        const response = await usePost('/api/2fa/setup/phone/', { phone: '+' + phone, userID: userID }, csrf, false)
        if (response.success) {
          setSubmittedPhone(true)
        }
      } else {
        // Send token to the server
        const response = await usePost(
          '/api/2fa/verify/phone/',
          { phone: '+' + phone, token: code, userID: userID },
          csrf,
          false
        )
        if (response.success) {
          notify({ type: 'success', message: 'SMS/Text Message setup successfully' })
          if (userID) {
            // Logged in user, direct to dashboard
            window.location.href = '/'
          }
          setCurrentPhoneNumber(phone)
          setSubmittedPhone(false)
          setPhone('')
          setCode('')
          setSmsOpen(false)
        }
      }
    }
    setValidated(false)
  }

  return (
    <GenericModal
      show={smsOpen}
      heading={<Modal.Title>SMS/Text Message Setup</Modal.Title>}
      onHide={() => setSmsOpen(false)}
      buttons={
        <div style={{ margin: '1em 0' }}>
          {currentPhoneNumber ? (
            <GlobalStyles.Button
              onClick={() => useDelete(`/api/core/users/${method?.user_id}/2fa/${method?.id}/`, csrf)}
              className="secondary"
              style={{ minWidth: 150 }}
            >
              Reset
            </GlobalStyles.Button>
          ) : (
            <GlobalStyles.Button onClick={handleSubmit} style={{ minWidth: 150 }}>
              Submit
            </GlobalStyles.Button>
          )}
        </div>
      }
    >
      <Form noValidate ref={node} validated={validated} onSubmit={handleSubmit} id="profile-form">
        <div style={{ padding: '2em', maxWidth: 400, margin: 'auto' }}>
          <Row>
            {currentPhoneNumber ? (
              <Form.Group>
                <Form.Label>Current Phone</Form.Label>
                <PhoneInput
                  inputProps={{
                    name: 'phone',
                  }}
                  inputStyle={{ width: '100%', backgroundColor: 'lightgrey' }}
                  country={'us'}
                  value={currentPhoneNumber}
                  disabled
                />
              </Form.Group>
            ) : null}
            {!currentPhoneNumber && (
              <Form.Group>
                <Form.Label>{currentPhoneNumber ? 'New Phone' : 'Phone'} </Form.Label>
                <PhoneInput
                  inputProps={{
                    name: 'phone',
                    required: true,
                    autoFocus: true,
                  }}
                  inputStyle={{ width: '100%' }}
                  country={'us'}
                  value={phone}
                  onChange={(phone: string) => setPhone(phone)}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter your phone number to receive an authentication code.
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Row>
          {submittedPhone && (
            <Row style={{ marginTop: '.6em' }}>
              <Form.Group>
                <p>Please enter the 6-digit authentication code sent to the phone number entered above.</p>
                <Form.Control
                  type="text"
                  placeholder="000000"
                  value={code}
                  onChange={(e: any) => setCode(e.target.value)}
                />
                <Form.Control.Feedback type="invalid">The code must be a 6-digit number</Form.Control.Feedback>
              </Form.Group>
            </Row>
          )}
        </div>
      </Form>
    </GenericModal>
  )
}
